"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneOptions = void 0;
/** @internal */
function cloneOptions(options) {
    if (options === null || options === undefined) {
        return {};
    }
    return deepClone(options);
}
exports.cloneOptions = cloneOptions;
function deepClone(value) {
    if (value === null || typeof value !== "object") {
        return value;
    }
    if (Array.isArray(value)) {
        const result = [];
        for (const item of value) {
            result.push(deepClone(item));
        }
        return result;
    }
    // Only deep-clone plain objects. Anything with a non-Object prototype
    // (RegExp, Buffer, Date, class instances, ...) is returned by reference.
    const proto = Object.getPrototypeOf(value);
    if (proto !== Object.prototype && proto !== null) {
        return value;
    }
    const result = {};
    for (const key of Object.keys(value)) {
        result[key] = deepClone(value[key]);
    }
    return result;
}
//# sourceMappingURL=options.js.map